<template>
  <div class="nerveList">
    <el-card shadow="never">
      <div class="header-flex">
        <h1>经络</h1>
        <div class="input-flex">
          <div class="flex-right">
            <!-- <el-input
              placeholder="请输入搜索内容"
              v-model.lazy="keyword"
              prefix-icon="el-icon-search"
              clearable
              class="input"
            ></el-input> -->
            <el-button type="primary" size="small" @click="addNerve"
              >添加</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="type" label="类型">
          <template slot-scope="scope">
            <div>{{ scope.row.type | filterType }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="abbr" label="经络汇总"></el-table-column>
        <el-table-column prop="name" label="经络名称"></el-table-column>
        <el-table-column prop="sub_name" label="子午流注"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="
                deleteRow(scope.$index, scope.row, tableData)
              "
              size="small"
              type="danger"
              >删除</el-button
            >
            <el-button
              @click.native.prevent="
                editRow(scope.$index, scope.row, tableData)
              "
              size="small"
              type="primary"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </el-card>

    <!-- 添加对话框 -->
    <el-dialog title="输入框" :visible.sync="dialogVisible" width="50%">
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        :label-width="`${5}rem`"
      >
        <el-form-item label="选择类型" prop="type">
          <el-select
            v-model="form.type"
            placeholder="请选择类型"
            style="width:100%;"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经络汇总" prop="abbr">
          <el-input v-model="form.abbr" placeholder="请输入经络汇总"></el-input>
        </el-form-item>
        <el-form-item label="经络名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入经络名称"></el-input>
        </el-form-item>
        <el-form-item label="子午流注" prop="sub_name">
          <el-input
            v-model="form.sub_name"
            placeholder="请输入子午流注"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="form.sort" placeholder="请输入排序编号"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  saveCategory,
  categoryList,
  delAcupointCategory,
} from "@/api/acupoint";
export default {
  name: "nerveList",
  data() {
    return {
      typeOptions: [
        { key: 1, name: "成人穴位" },
        { key: 2, name: "小儿穴位" },
      ], // 类型
      tableData: [],
      total: 101,
      currentPage: 1,
      pageSize: 10,
      keyword: "",
      dialogVisible: false,
      submitType: 1, // 提交类型 1:添加  2:编辑
      form: {
        abbr: "",
        name: "",
        sub_name: "",
        sort: "",
        type: "",
      },
      options: [
        { id: 1, name: "成人" },
        { id: 2, name: "小儿" },
      ],
      rules: {
        abbr: [{ required: true, message: "请输入经络汇总", trigger: "blur" }],
        name: [{ required: true, message: "请输入经络名称", trigger: "blur" }],
        sub_name: [
          { required: true, message: "请输入子午流注", trigger: "blur" },
        ],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
    };
  },
  created() {
    this.$store.dispatch("fullscreenLoading", true);
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 获取分类列表
    getData() {
      categoryList({
        page: this.currentPage,
        limit: this.pageSize,
      }).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.$store.dispatch("fullscreenLoading", false);
      });
    },
    // 改变单页数量
    handleSizeChange(val) {
      this.$store.dispatch("fullscreenLoading", true);
      this.pageSize = val;
      this.getData();
    },
    // 更换页面
    handleCurrentChange(val) {
      this.$store.dispatch("fullscreenLoading", true);
      this.currentPage = val;
      this.getData();
    },
    // 添加经络
    addNerve() {
      this.submitType = 1;
      this.dialogVisible = true;
    },
    // 删除项
    deleteRow(index, row, tableData) {
      this.$confirm("是否要删除该项以及该项下面的所有的穴位?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delAcupointCategory({
          id: row.id,
        }).then(() => {
          this.$store.dispatch("fullscreenLoading", true);
          this.getData();
          tableData.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
      });
    },
    // 编辑项
    editRow(index, row) {
      this.submitType = 2;
      Object.keys(row).map((e) => {
        this.form[e] = row[e];
      });
      this.dialogVisible = true;
    },
    // 确认提交
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const id = this.submitType == 1 ? 0 : this.submitType;
          saveCategory({
            id,
            ...this.form,
          }).then(() => {
            this.$store.dispatch("fullscreenLoading", true);
            this.getData();
            this.$message({
              showClose: true,
              message: id == 0 ? "添加成功" : "编辑成功",
              type: "success",
            });
            this.$refs[formName].resetFields();
            this.dialogVisible = false;
          });
        } else {
          this.$message.error("输入内容有误");
          return false;
        }
      });
    },
  },
  filters: {
    filterType(val) {
      const type = {
        0: "旧数据",
        1: "成人穴位",
        2: "小儿穴位",
      };
      return type[val];
    },
  },
};
</script>

<style scoped>
.header-flex {
  display: flex;
  align-items: center;
}

.input-flex {
  flex: 1;
  text-align: right;
}

.input {
  width: 207px;
  margin-right: 20px;
}

.flex-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 15px;
}
</style>
